<template>
	<div class="" v-if="products.length > 0">
		<VueSlickCarousel ref="carousel" v-bind="slickSettings">
			<div v-for="product in products" :key="product.id" class="p-1">
				<Product :product="product" btnText="VENDER" @clicked="productClicked" />
			</div>
		</VueSlickCarousel>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import Product from './Product'

export default {
	name: 'FeaturedProducts',
	components: {
		Product,
	},
	data() {
		return {
			loading: true,
			products: [],
			slickSettings: {
				arrows: false,
				dots: false,
				autoplay: true,
				autoplaySpeed: 5000,
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
					{
						breakpoint: 780,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						},
					},
				],
			},
		}
	},
	beforeMount() {
		this.loading = false
		this.load()
	},

	methods: {
		productClicked(product) {
			console.log('productClicked')
			this.$router.push(`/sell?product=${product.id}`)
		},
		load() {
			this.$apollo
				.query({
					query: gql`
						query($featured: Boolean) {
							products(featured: $featured) {
								data {
									id
									code
									name
									slug
									points
									image
								}
								pageInfo {
									totalItems
								}
							}
						}
					`,
					variables: {
						featured: true,
					},
					fetchPolicy: 'no-cache',
				})
				.then(({ data }) => {
					this.products = data.products.data
					this.loading = false
				})
		},
	},
}
</script>

<style scoped>
.slide {
	margin-top: 26px;
	border-radius: 12px;
	background-color: #fff;
	width: 100%;
	display: flex;
	align-items: center;
	overflow: hidden;
}
</style>
